module.exports = new __parcel__URL__("home_officiate.d192282b.webp").toString();